import { connect } from "react-redux";
import RevalidateBefore from "components/v3/revalidate-before/RevalidateBefore";
import loginRegister from "ducks/loginRegister";

export function createMapStateToProps() {
    return (state, ownProps) => {
        const {
            loginRegister: {
                password,
                reauthorized,
                errors
            },
            user: {
                email
            },
            config : {
                grecaptchaApiKey
            },
            thinking
        } = state;

        return {
            email,
            password,
            thinking,
            reauthorized,
            grecaptchaApiKey,
            errors,
            WrappedComponent: ownProps.WrappedComponent
        };
    };
}

export function mapDispatchToProps(dispatch) {
    return {
        reauthorizeFromUser() {
            dispatch(loginRegister.reauthorizeFromUser());
        },

        reauthorizeWithPassword(password, captcha) {
            return dispatch(loginRegister.reauthorizeWithPassword(password, captcha));
        },

        onPasswordChange(password) {
            dispatch(loginRegister.passwordChange(password));
        }
    };
}

export default connect(createMapStateToProps(), mapDispatchToProps)(RevalidateBefore);
